import { useRouter } from '@application/utils';
import type { StepLineStep } from '@presentation/components';
import {
  Button,
  InputWrapper,
  Section,
  SectionText,
  SectionTitle,
  StepLine,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { TbArrowNarrowRight } from 'react-icons/tb';
import dogCool from '../../assets/dog-cool-success.png';
import * as Styled from './styled';
import type { SuccessProps } from './types';

export const Success: FC<SuccessProps> = (props) => {
  const { firstName, checkoutLoading, onCheckoutClick } = props;
  const { routeLocationDescriptor } = useRouter();
  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'application.steps.success',
  });

  const stepsSuccess: StepLineStep[] = [
    { title: translateRessource('steps.one') },
    { title: translateRessource('steps.two') },
    { title: translateRessource('steps.three') },
    { title: translateRessource('steps.four') },
  ];

  return (
    <Styled.Wrapper>
      <Styled.ImageWrapper>
        <img src={dogCool} alt="" />
      </Styled.ImageWrapper>
      <Styled.Section>
        <Section>
          <SectionTitle>{translateRessource('title').replace('$name', firstName)}</SectionTitle>
          <SectionText>{translateRessource('text')}</SectionText>

          <Styled.StepLineWrapper>
            <StepLine
              currentStep={1}
              steps={stepsSuccess}
              color="dark"
              verticalBreakpoint={10000} // We want it always vertical
            />
          </Styled.StepLineWrapper>

          <div>
            {onCheckoutClick && (
              <InputWrapper split>
                <Button
                  onClick={onCheckoutClick}
                  iconRight={<TbArrowNarrowRight />}
                  color="blue"
                  loading={checkoutLoading}
                >
                  {translate('common.buttons.pay')}
                </Button>
              </InputWrapper>
            )}
            <InputWrapper split={!!onCheckoutClick} last>
              <Button color="blue" outlined link={routeLocationDescriptor('mtApplications')}>
                {translate('common.buttons.payLater')}
              </Button>
            </InputWrapper>
          </div>
        </Section>
      </Styled.Section>
    </Styled.Wrapper>
  );
};
